import { Action } from '@ngrx/store';
import { ActionBase } from "../../../core/store/action/ActionBase";

export const MANAGE_ROLE_ERROR = '[Security] Manage Role Error';

export class ManageRoleErrorAction implements Action {
  readonly type = MANAGE_ROLE_ERROR;
  payload: { action: ActionBase, errors: string[] };

  constructor(action: ActionBase, errors: string[]) {
    this.type = MANAGE_ROLE_ERROR;
    this.payload = {
      action: action,
      errors: errors
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/ManageRoleErrorAction.ts